import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import NavBar from './NavBar';

const mapStateToProps = ({ site }) => {
    return {
        appTitle: site.title,
        appFeatures: site.features,
    };
};

export default withRouter(connect(mapStateToProps)(NavBar));
